<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0"></div>
<p class="calibre3"><span id="pgepubid00002" title="[vii]"><a id="Page_vii" title="[vii]"></a></span></p>
<h2 class="calibre" id="pgepubid00003">CONTENTS.</h2>
<div class="center2">
<table border="0" cellpadding="1" cellspacing="0" class="toc" summary="Contents">
<tbody class="calibre8"><tr class="calibre9"><td class="tocchapter"></td>
<td class="toctitle"></td>
<td class="tocpage">PAGE</td>
</tr>
<tr class="calibre9"><td class="tocchapter"></td>
<td class="toctitle">PROLOGUE</td>
<td class="tocpage"><a href="#/Text/Section0005">1</a></td>
</tr>
<tr class="calibre9"><td class="tocchapter1">CHAP.</td>
<td class="toctitle"></td>
<td class="tocpage"></td>
</tr>
<tr class="calibre9"><td class="tocchapter">I.</td>
<td class="toctitle">THE SURRENDER OF THE WORLD-THRONE</td>
<td class="tocpage"><a href="#/Text/Section0006#Page_8">8</a></td>
</tr>
<tr class="calibre9"><td class="tocchapter">II.</td>
<td class="toctitle">A CROWNLESS KING</td>
<td class="tocpage"><a href="#/Text/Section0007#Page_14">14</a></td>
</tr>
<tr class="calibre9"><td class="tocchapter">III.</td>
<td class="toctitle">TSARINA OLGA</td>
<td class="tocpage"><a href="#/Text/Section0008#Page_26">26</a></td>
</tr>
<tr class="calibre9"><td class="tocchapter">IV.</td>
<td class="toctitle">A SON OF THE GODS</td>
<td class="tocpage"><a href="#/Text/Section0009#Page_35">35</a></td>
</tr>
<tr class="calibre9"><td class="tocchapter">V.</td>
<td class="toctitle">A VISION FROM THE CLOUDS</td>
<td class="tocpage"><a href="#/Text/Section0010#Page_47">47</a></td>
</tr>
<tr class="calibre9"><td class="tocchapter">VI.</td>
<td class="toctitle">DEED AND DREAM</td>
<td class="tocpage"><a href="#/Text/Section0011#Page_53">53</a></td>
</tr>
<tr class="calibre9"><td class="tocchapter">VII.</td>
<td class="toctitle">THE SPELL OF CIRCE</td>
<td class="tocpage"><span href="#/Text/Section0012#Page_66" title="Link target outside of Sample">66</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">VIII.</td>
<td class="toctitle">THE NEW TERROR</td>
<td class="tocpage"><span href="#/Text/Section0013#Page_75" title="Link target outside of Sample">75</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">IX.</td>
<td class="toctitle">THE FLIGHT OF THE “REVENGE”</td>
<td class="tocpage"><span href="#/Text/Section0014#Page_83" title="Link target outside of Sample">83</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">X.</td>
<td class="toctitle">STRANGE TIDINGS TO AERIA</td>
<td class="tocpage"><span href="#/Text/Section0015#Page_94" title="Link target outside of Sample">94</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XI.</td>
<td class="toctitle">THE SNAKE IN EDEN</td>
<td class="tocpage"><span href="#/Text/Section0016#Page_102" title="Link target outside of Sample">102</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XII.</td>
<td class="toctitle">THE BATTLE OF KERGUELEN</td>
<td class="tocpage"><span href="#/Text/Section0017#Page_110" title="Link target outside of Sample">110</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XIII.</td>
<td class="toctitle">THE SYREN’S STRONGHOLD</td>
<td class="tocpage"><span href="#/Text/Section0018#Page_129" title="Link target outside of Sample">129</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XIV.</td>
<td class="toctitle">FROM THE SEA TO THE AIR</td>
<td class="tocpage"><span href="#/Text/Section0019#Page_138" title="Link target outside of Sample">138</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XV.</td>
<td class="toctitle">OLGA IN COUNCIL</td>
<td class="tocpage"><span href="#/Text/Section0020#Page_146" title="Link target outside of Sample">146</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XVI.</td>
<td class="toctitle">KHALID THE MAGNIFICENT</td>
<td class="tocpage"><span href="#/Text/Section0021#Page_159" title="Link target outside of Sample">159</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XVII.</td>
<td class="toctitle">AN UNHOLY ALLIANCE</td>
<td class="tocpage"><span href="#/Text/Section0022#Page_174" title="Link target outside of Sample">174</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XVIII.</td>
<td class="toctitle">A MOMENTOUS COMMISSION</td>
<td class="tocpage"><span href="#/Text/Section0023#Page_188" title="Link target outside of Sample">188</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XIX.</td>
<td class="toctitle">FACE TO FACE AGAIN</td>
<td class="tocpage"><span href="#/Text/Section0024#Page_202" title="Link target outside of Sample">202</span><span id="pgepubid00004" title="[viii]"><a id="Page_viii" title="[viii]"></a></span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XX.</td>
<td class="toctitle">THE CALL TO ARMS</td>
<td class="tocpage"><span href="#/Text/Section0025#Page_215" title="Link target outside of Sample">215</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXI.</td>
<td class="toctitle">THE HOME-COMING</td>
<td class="tocpage"><span href="#/Text/Section0026#Page_226" title="Link target outside of Sample">226</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXII.</td>
<td class="toctitle">THE EVE OF BATTLE</td>
<td class="tocpage"><span href="#/Text/Section0027#Page_243" title="Link target outside of Sample">243</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXIII.</td>
<td class="toctitle">THE FIRST BLOW</td>
<td class="tocpage"><span href="#/Text/Section0028#Page_253" title="Link target outside of Sample">253</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXIV.</td>
<td class="toctitle">WAR AT ITS WORST</td>
<td class="tocpage"><span href="#/Text/Section0029#Page_271" title="Link target outside of Sample">271</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXV.</td>
<td class="toctitle">A MESSAGE FROM MARS</td>
<td class="tocpage"><span href="#/Text/Section0030#Page_289" title="Link target outside of Sample">289</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXVI.</td>
<td class="toctitle">SENTENCE OF DEATH</td>
<td class="tocpage"><span href="#/Text/Section0031#Page_303" title="Link target outside of Sample">303</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXVII.</td>
<td class="toctitle">ALMA SPEAKS</td>
<td class="tocpage"><span href="#/Text/Section0032#Page_314" title="Link target outside of Sample">314</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXVIII.</td>
<td class="toctitle">THE SIGN IN THE SKY</td>
<td class="tocpage"><span href="#/Text/Section0033#Page_319" title="Link target outside of Sample">319</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXIX.</td>
<td class="toctitle">THE TRUCE OF GOD</td>
<td class="tocpage"><span href="#/Text/Section0034#Page_325" title="Link target outside of Sample">325</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXX.</td>
<td class="toctitle">THE SHADOW OF DEATH</td>
<td class="tocpage"><span href="#/Text/Section0035#Page_338" title="Link target outside of Sample">338</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXXI.</td>
<td class="toctitle">THE LAST BATTLE</td>
<td class="tocpage"><span href="#/Text/Section0036#Page_350" title="Link target outside of Sample">350</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter">XXXII.</td>
<td class="toctitle">THE SHE-WOLF TO HER LAIR</td>
<td class="tocpage"><span href="#/Text/Section0037#Page_359" title="Link target outside of Sample">359</span></td>
</tr>
<tr class="calibre9"><td class="tocchapter"></td>
<td class="toctitle1">EPILOGUE</td>
<td class="tocpage"><span href="#/Text/Section0038#Page_369" title="Link target outside of Sample">369</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?e2ac0d90